import React, {Component} from 'react';
import RDP_CONFIG from '../../config';
import Navigation from "../../components/element-navigation/navigation";
import classNameFn from "../../utils/classNameFn";
import QuizCard from "../../components/element-quiz-card/quiz-card";
import ElementQuizQuestion from "../../components/element-quiz-question/element-quiz-question";
import QuizFinishResult from "../../components/element-quiz-finish-result/quiz-finish-result";
import useQuestionIsCorrect from "../../hooks/useQuestionIsCorrect";
import * as S from "./element-quiz-3.styled";

export default class ElementQuiz3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: this.props.content,
      contentBkp: this.props.content,
      activeChoices: [],
      answeredQuestionsIds: [],
      currentQuestionIndex: 0,
      showResult: false,
      ai_feedback: null
    }

    this.onFinishClick = this.onFinishClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.content !== prevProps.content) {
      this.sortQuestions();
    }
  };

  getLabels = () => {
    const {
      content: {
        questions = []
      }
    } = this.state;
    const {
      contentLanguage = "pt_br"
    } = this.props;

    const labels = {
      en: {
        confirm: "Confirm",
        question: "Question",
        back: "Back",
        retry: "Try again",
        previous: "Previous",
        next: "Next",
        finish: questions.length > 1 ? "Send answers" : "Send answer",
        incorrect: "Incorrect",
        right: "Right!",
        finish_quiz_message: "You have completed this quiz.",
        edit: "Edit",
        answer_saved: "Answer saved!",
      },
      pt_br: {
        confirm: "Confirmar",
        question: "Questão",
        retry: "Refazer atividade",
        previous: "Anterior",
        next: "Próximo",
        finish: questions.length > 1 ? "Enviar respostas" : "Enviar resposta",
        incorrect: "Incorreto",
        right: "Correto!",
        finish_quiz_message: "Você finalizou este questionário.",
        edit: "Editar resposta",
        answer_saved: "Resposta salva!",
      }
    }

    return labels[contentLanguage] || labels["en"];
  }

  isFinishButtonVisible = () => {
    const {currentQuestionIndex, content} = this.state;
    const {questions} = content;
    let current = currentQuestionIndex + 1;
    let questions_count = questions.length;

    return current === questions_count;
  }

  isFinishButtonDisabled = () => {
    const {content, answeredQuestionsIds} = this.state;
    const {questions} = content;
    let answeredQuestions = questions.filter(q => answeredQuestionsIds.includes(q.id));

    return questions.length !== answeredQuestions.length;
  }

  updateContentAndNotifyChange = (content) => {
    this.setState({
      content
    }, () => {
      this.props.onChange(this.state.content)
    });
  }

  setAnswer = (questionId, choice) => {
    let {activeChoices} = this.state;

    this.setState({activeChoices: {...activeChoices, [questionId]: choice}});
  }

  setAnswerConfirmation = (questionId) => {
    const {answeredQuestionsIds} = this.state;
    this.setState({
      answeredQuestionsIds: [...answeredQuestionsIds, questionId]
    })
  }

  deleteAnswerConfirmation = (questionId) => {
    const {answeredQuestionsIds} = this.state;
    this.setState({
      answeredQuestionsIds: answeredQuestionsIds.filter(id => id !== questionId)
    })
  }

  getContentOnlyWithQuestion = (question) => {
    const {
      content,
    } = this.state;

    let contentCopy = {...content};
    contentCopy.questions = [question];

    return contentCopy;
  }

  goToPreviusQuestion = () => {
    const {currentQuestionIndex} = this.state;
    this.setState({
      currentQuestionIndex: currentQuestionIndex - 1
    });
  }

  goToNextQuestion = () => {
    const {currentQuestionIndex} = this.state;
    this.setState({
      currentQuestionIndex: currentQuestionIndex + 1
    });
  }

  renderContentFor = (currentQuestionIndex) => {
    const {
      editable,
      contentLanguage,
      headerActionsTemplate,
      footerActionsTemplate,
    } = this.props;
    const {
      content,
      showResult,
      activeChoices,
      answeredQuestionsIds,
      grades,
    } = this.state;
    const {
      questions,
      primary_color
    } = content;

    if (showResult) {
      return (
        <QuizFinishResult
          grades={grades}
          labels={this.getLabels()}
          onClickRemake={this.resetState}
          content={content}
          contentLanguage={contentLanguage}
        />
      )
    } else if (questions) {
      let question = questions[currentQuestionIndex];
      question.type = "quiz-3";

      return (
        <>
          <ElementQuizQuestion
            data={question}
            answered={answeredQuestionsIds.includes(question.id)}
            labels={this.getLabels()}
            editable={editable}
            content={this.getContentOnlyWithQuestion(question)}
            questionNumber={currentQuestionIndex}
            questionTotal={questions.length}
            contentLanguage={contentLanguage}
            headerActionsTemplate={headerActionsTemplate}
            footerActionsTemplate={footerActionsTemplate}
            activeChoices={activeChoices}
            onAnswering={this.setAnswer}
            onConfirmAnswer={this.setAnswerConfirmation}
            onResetAnswer={this.deleteAnswerConfirmation}
            onUpdateContent={this.updateContentAndNotifyChange}
          />
          <Navigation
            showFinishButton={this.isFinishButtonVisible()}
            disableFinishButton={this.isFinishButtonDisabled()}
            currentProgress={currentQuestionIndex + 1}
            totalProgress={questions.length}
            primaryColor={primary_color}
            labels={this.getLabels()}
            activeChoices={activeChoices}
            onClickPrevius={this.goToPreviusQuestion}
            onClickNext={this.goToNextQuestion}
            onClickFinish={this.onFinishClick}
          />
        </>
      )
    }

    return null;
  }

  onFinishClick() {
    const { content } = this.state;
    const questions = content.questions || [];
    
    const resume = {
      rdp_html_content: {
        questions: questions,
        hits: 0,
        total: questions.length,
        percentage_average: 0,
        min_percentage: content.utilization ? content.utilization.percentage : 0,
      },
    };

    this.setState({
      showResult: true,
      grades: resume,
      answered: true
    }, () => {
      const hasAiFeedback = this.hasAiFeedback();
      const hasAiConnector = this.props.hasAiConnector;

      if (hasAiFeedback && hasAiConnector && !this.state.ai_feedback) {
        this.onSubmitAiFeedbackRender();
      }
    });
  }

  resetState = () => {
    this.setState({
      answered: false,
      grades: null,
      showResult: false,
      currentQuestionIndex: 0,
      activeChoices: [],
      answeredQuestionsIds: [],
    })

    this.sortQuestions(true);
  }

  sortQuestions(isRemake = false) {
    const contentCopy = { ...this.props.content };
    var splitQuestions = contentCopy.number_of_questions_to_display !== undefined && contentCopy.number_of_questions_to_display > 0;
    var randomizeOnRemake = contentCopy.random_on_remake !== undefined && contentCopy.random_on_remake.enabled === true;
    var sortQuestions = contentCopy.random_question_order !== undefined && contentCopy.random_question_order.enabled === true;

    if ((randomizeOnRemake && isRemake) || !isRemake) {
      const backup = this.props.content.questions;
      var newQuestions = this.props.content.questions;

      if (sortQuestions) {
        newQuestions.sort((a, b) => {
          return Math.floor(Math.random() * (1 - -1)) + -1;
        });
      }

      if (splitQuestions) {
        newQuestions = newQuestions.slice(0, contentCopy.number_of_questions_to_display);
      }

      contentCopy.questions = newQuestions;

      this.props.content.questions = backup;
      this.setState({
        content: contentCopy
      })
    }

    return contentCopy;
  }

  getFont = (font) => {
    if (font) return font.replace(/\s/g, '-').toLowerCase();
  }

  hasAiFeedback() {
    const { content } = this.state;
    return (content.final_ai_feedback && content.final_ai_feedback.enabled) ? true : false;
  }

  getResultLabel(hits, total, percentage) {
    var language = this.props.contentLanguage;
    if (language === "en") {
      return `You got ${hits} of ${total} questions right, equivalent to ${percentage} of the quiz.`
    } else if (language === "pt_br") {
      return `Você acertou ${hits} de ${total} questões, o equivalente a ${percentage} do questionário.`
    };
  }

  renderFinalMessage(grades) {
    var feedback = this.state.content.feedback.type;

    return <>
      <span className="rdp-react-quiz-result-icon"></span>
      {feedback === "disabled" &&
        <span className="rdp-react-quiz-result-message">{this.getLabels().finish_quiz_message}</span>
      }
      {feedback !== "disabled" &&
        <span className="rdp-react-quiz-result-message">{this.getResultLabel(grades.hits, grades.total, `${parseFloat(grades.percentage_average).toFixed(0)}%`)}</span>
      }
    </>
  }

  renderAiFeedback() {
    const { ai_feedback } = this.state;

    if (ai_feedback === null) {
      return <span className="rdp-react-quiz-3-result-preloader"></span>
    } else {
      return <div className="rdp-react-quiz-3-result-ai">
        <span className="rdp-react-quiz-3-result-ai-icon"></span>
        <span className="rdp-react-quiz-3-result-ai-message" dangerouslySetInnerHTML={{ __html: ai_feedback }}></span>
      </div>
    }
  }

  async onSubmitAiFeedbackRender() {
    const { content, activeChoices } = this.state;
    var questions = content.questions;

    const updatedQuestions = questions.map(question => {
      const selectedChoices = activeChoices[question.id] || [];
    
      return {
        ...question,
        choices: question.choices.map(choice => ({
          ...choice,
          answered: selectedChoices.includes(choice.id)
        }))
      };
    });

    var prompt = `Com base nestas instruções:
      ${content && content.final_ai_feedback.instruction}

      Retorne a mensagem de feedback para o usuário com base nesse questionário respondido diretamente, sem outros textos, em que cada resposta preenchida é marcada como answered: true:

      '${JSON.stringify(updatedQuestions)}'
    `

    if (content.final_ai_feedback.style_guide !== "") {
      prompt += `Utilizando o guia de estilo abaixo:

      '${content.final_ai_feedback.style_guide}'
      `
    }

    if (content.final_ai_feedback.reference_text !== "") {
      prompt += `Utilizando o texto de referência abaixo:

      '${content.final_ai_feedback.reference_text}'
      `
    }

    var connectors = JSON.parse(window.localStorage.getItem("rdp-composer-active-project")).connectors;
    var aiConnectorUid = connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    var userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    var apiUrl = `https://${RDP_CONFIG.domain}/insights/v1.1/generative/connector/uid/${aiConnectorUid}/response`

    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${userData.access_token}`,
        "Api-Env": RDP_CONFIG.apiEnv,
        "Project-Key": RDP_CONFIG.projectKey
      },
      body: JSON.stringify({
        "prompt": prompt
      })
    };

    var resposta = "";

    let decoder = new TextDecoder();
    let result = "";

    const response = await fetch(apiUrl, options);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const reader = response.body.getReader();

    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      resposta = `<p><span style="font-size: 18px;">${result += decoder
        .decode(value, { stream: true })
        .replace(/(\r?\n|\r)/g, "")
        .replace(/\s+/g, " ")}
      </span></p>`
    }

    debugger;

    this.setState({
      "ai_feedback": resposta
    })

    console.log(resposta);
  }

  renderResult() {
    const { content, showResult } = this.state;
    var feedback = this.state.content.feedback.type;
    if (showResult === true) {
      var grades = this.state.grades.rdp_html_content;
      return (
        <div className="rdp-react-quiz-result">
          {!this.hasAiFeedback() && this.renderFinalMessage(grades)}
          {this.hasAiFeedback() && this.renderAiFeedback()}
          {content.remake == "enable" && <div className="rdp-react-quiz-remake-btn" onClick={() => this.onRemakeQuestionnaire()}>
            <span className="rdp-react-quiz-remake-btn-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" space="preserve">
                <g>
                  <path fill={content.primary_color ? content.primary_color : "#111111"} d="M126.97,328.84c-5.84,0-11.63-2.42-15.78-7.15L5.17,200.31c-6.89-7.88-6.89-19.64,0-27.53L111.19,51.41   c7.61-8.7,20.83-9.59,29.53-1.99c8.71,7.6,9.59,20.82,2,29.52l-94,107.61l94,107.6c7.6,8.7,6.71,21.92-2,29.52   C136.75,327.14,131.85,328.84,126.97,328.84z" />
                  <path fill={content.primary_color ? content.primary_color : "#111111"} d="M359.93,469.75H48.83c-11.56,0-20.93-9.37-20.93-20.93s9.37-20.93,20.93-20.93h311.1   c60.78,0,110.22-49.44,110.22-110.21s-49.44-110.21-110.22-110.21h-339C9.37,207.47,0,198.1,0,186.54   c0-11.55,9.37-20.92,20.93-20.92h339c83.85,0,152.07,68.22,152.07,152.06C512,401.53,443.77,469.75,359.93,469.75z" />
                </g>
              </svg>
            </span>
            <span className="rdp-react-quiz-remake-btn-text">{this.getLabels().retry}</span>
          </div>}
        </div >
      );
    }
  }

  render() {
    const {
      headerActionsTemplate,
      footerActionsTemplate,
      content,
      className
    } = this.props;
    const {
      currentQuestionIndex,
    } = this.state;

    return (
      <S.ElementQuizContainer
        className={classNameFn([
          className,
          this.getFont(content.font_family) || ""
        ])}
        style={{
          background: content.background_color,
          paddingTop: content.padding_top + "px",
          paddingBottom: content.padding_bottom + "px"
        }}
      >
        {headerActionsTemplate}

        <QuizCard>
          {this.renderContentFor(currentQuestionIndex)}
        </QuizCard>

        {footerActionsTemplate}
      </S.ElementQuizContainer>
    )
  }

}
